import React from "react";
import { Form, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { withRouter } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import logo from "../../../assets/logo.png";
import { modalType } from "../../../modules/constants";
import {
  mapDispatchToPropsLayout,
  mapStateToPropsLayout,
} from "../../../modules/layout";
import {
  getUserDefaultRoute,
  mapDispatchToPropsLogin,
  mapStateToPropsLogin,
} from "../../../modules/login";
import UserImage from "../UserImage/UserImage";
import UserName from "../UserName/UserName";

const StyledNavbar = styled(Navbar)`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
`;

const StyledLinkContainer = styled(LinkContainer)`
  &.active,
  &.dropdown-item:active {
    background-color: ${(props) => props?.theme?.darkPurple};
  }
`;

const ButtonSidebar = styled.button`
  color: ${(props) => props?.theme?.gray};
  border: 0;
  background-color: transparent;
  line-height: 1;
  margin-left: -5px;
  padding: 5px 10px;
  &.hover {
    color: ${(props) => props?.theme?.darkPurple};
  }
  @media (min-width: 768px) {
    width: 50px;
    margin-left: 0;
  }
`;

const Navigation = (props) => {
  return (
    <StyledNavbar collapseOnSelect fixed="top" className="navbar-shadow">
      {props.isLogged && props.withSidebar && (
        <ButtonSidebar
          type="button"
          className="btn-sidebar"
          data-testid="btn-sidebar"
          onClick={() => props.toggleLayoutSidebar()}
        >
          <span>
            <i className="fas fa-bars" aria-hidden="true"></i>
          </span>
        </ButtonSidebar>
      )}
      <Navbar.Brand style={{ padding: "0", margin: "0" }}>
        <LinkContainer
          to={getUserDefaultRoute(props.userProfile, props.studies)}
          title="Home"
          className="navbar-logo"
        >
          <img src={logo} alt="Rarify logo" />
        </LinkContainer>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto" />
        {props.isLogged ? (
          <UserActions
            userProfile={props.userProfile}
            logout={props.logout}
            setPreventNavigation={props.setPreventNavigation}
            history={props.history}
            preventNavigation={props.preventNavigation}
            studies={props.studies}
            name={props.accountName || props.accountUserName}
          />
        ) : (
          <LoginButtons {...props} />
        )}
      </Navbar.Collapse>
    </StyledNavbar>
  );
};

const LoginButtons = (props) => {
  const { t } = useTranslation();
  return (
    <Nav className="float-right">
      <Form inline>
        <button
          className="btn btn-sm btn-primary mr-1"
          name="login"
          id="login"
          type="button"
          data-toggle="modal"
          data-target="#login"
          onClick={() =>
            props.setOpenAuthModal(
              modalType.login,
              t("contentText.login.title")
            )
          }
        >
          {t("Login")}
        </button>
      </Form>
    </Nav>
  );
};

const UserActions = (props) => {
  const { t } = useTranslation();

  return (
    <Nav className="mr-lg-3">
      <Nav.Item className="navbar-user-icon-item">
        <Nav.Link eventKey="2">
          <UserImage
            callback={() => {}}
            id="user-image"
            className="img-user mr-2"
          />
        </Nav.Link>
      </Nav.Item>

      <NavDropdown
        title={
          <UserName
            userName={props.name}
            defaultValue={t("appText.myAccount")}
          />
        }
        id="collasible-nav-dropdown"
        className="username-dropdown"
      >
        {studiesDropdownOptions(props.userProfile, props.studies)}
        <LinkContainer
          to="#"
          title={t("appText.logout")}
          className="dropdown-item"
          onClick={() => {
            props.setPreventNavigation(false).then(() => {
              props.logout();
              props.history.push("/home");
            });
          }}
        >
          <NavDropdown.Item>{t("appText.logout")}</NavDropdown.Item>
        </LinkContainer>
      </NavDropdown>
    </Nav>
  );
};

const studiesDropdownOptions = (role, userStudies) => {
  return userStudies?.map((study) => {
    return (
      <StyledLinkContainer
        to={"/study"}
        title={study.code}
        className="dropdown-item"
        key={study.studyId}
      >
        <NavDropdown.Item>{study.code}</NavDropdown.Item>
      </StyledLinkContainer>
    );
  });
};

const mapDispatchToProps = {
  ...mapDispatchToPropsLogin,
  ...mapDispatchToPropsLayout,
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsLayout(state),
    ...mapStateToPropsLogin(state),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(Navigation)));
